import React, { useEffect, useState } from "react";
import { Loader } from "../Loader/Loader";
import { Avatar, Badge, Empty, Select, Space } from "antd";
import { List, Row, Col, Typography } from "antd";
import { ArrowUpOutlined, LeftOutlined } from "@ant-design/icons";
import btc from "../Assets/btc.png";
import eur from "../Assets/eur.png";
import { motion } from "framer-motion";
import Axios from "../Axios";
import { useLayout } from "../Context/LayoutContext";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const { Text } = Typography;



const TradeHitorySide = ({ loader, setCollapsed }) => {
  // animation
  const screen = useBreakpoint()
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const child = {
    hidden: { opacity: 0, y: 5 },
    show: { opacity: 1, y: 0 },
  };

  const [data, setData] = useState([]);
  const [tradeHistory, setTradeHistory] = useState([]);
  const [type, setType] = useState("binary");

  const getTradeHistory = async () => {
    try {
      const { data } = await Axios.post("/users/getTradeHistory", { type: type }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("nzanzi")}`,
        }
      });
      if (data?.success) {
        setTradeHistory(data?.result);
      }
      else {
        setTradeHistory([]);
      }
    } catch (error) {
      setTradeHistory([]);
      console.log("Error fetching trade history:", error);
    }
  }

  const getClosedPositions = async () => {
    try {
      const { data } = await Axios.post(
        "/ownTrade/getFutureTradeHistory",
        {},
        {
          headers: {
            Authorization: localStorage.getItem("nzanzi"),
          },
        }
      );
      if (data?.success) {
        setTradeHistory(data?.result || []);
      } else {
        setTradeHistory([]);
      }
    } catch (e) {
      setTradeHistory([]);
      console.log(e);
    }
  };

  useEffect(() => {
    if (type == "future") {
      getClosedPositions();
    } else {
      getTradeHistory();
    }
  }, [type]);
  useEffect(() => {
    if (tradeHistory.length > 0) {
      if (type === "binary") {
        const formatedRow = [];
        for (let i = 0; i < tradeHistory.length; i++) {
          const obj = {};
          obj.time = tradeHistory[i]?.time;
          obj.date = tradeHistory[i]?.date;
          obj.icon = tradeHistory[i]?.url;
          obj.pair = tradeHistory[i]?.pair;
          obj.type = tradeHistory[i]?.direction;
          obj.result = tradeHistory[i]?.result
            ? +Number(tradeHistory[i].quantity)
            : -Number(tradeHistory[i].quantity);
          obj.investment = tradeHistory[i]?.quantity;
          formatedRow.push(obj);
          setData(formatedRow);
        }
      } else if (type === "pending" || type === "close") {
        const formatedRow = [];
        for (let i = 0; i < tradeHistory.length; i++) {
          const obj = {};
          obj.time = tradeHistory[i]?.createdAt;
          // obj.date = tradeHistory[i]?.date;
          obj.icon = tradeHistory[i]?.url;
          obj.pair = tradeHistory[i]?.symbol;
          obj.type = tradeHistory[i]?.side;
          obj.result = Number(tradeHistory[i]?.profit) > 0
            ? +Number(tradeHistory[i]?.profit).toFixed(5)
            : -Number(Math.abs(tradeHistory[i]?.profit)).toFixed(5);
          obj.investment = tradeHistory[i]?.quantity;
          formatedRow.push(obj);
          setData(formatedRow);
        }
      } else if (type === "future") {
        const formatedRow = [];
        for (let i = 0; i < tradeHistory.length; i++) {
          const obj = {};
          obj.time = tradeHistory[i]?.createdAt;
          // obj.date = tradeHistory[i]?.date;
          obj.icon = tradeHistory[i]?.url;
          obj.pair = tradeHistory[i]?.symbol?.replace("_", "");
          obj.type = tradeHistory[i]?.direction;
          obj.result = Number(tradeHistory[i]?.profit_loss) > 0
            ? +Number(tradeHistory[i]?.profit_loss).toFixed(5)
            : -Number(Math.abs(tradeHistory[i]?.profit_loss)).toFixed(5);
          obj.investment = tradeHistory[i]?.lot_size;
          formatedRow.push(obj);
          setData(formatedRow);
        }
      }
    } else {
      setData([])
    }
  }, [tradeHistory]);

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <motion.div variants={container} initial="hidden" animate="show" style={{ display: "flex", flexDirection: "column", flex: "1" }}>
            {screen.lg && <motion.div variants={child} className="trad-pos ar3">
              <div className="display-5 p-20 ">
                <div className="side-title display-1">
                  Trading History</div>
                <div
                  className="cursor nonea3"
                  onClick={() => setCollapsed(true)}
                  id="cs"
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z"
                      fill="#82858E"
                      stroke="#82858E"
                      stroke-width="1.5294"
                    />
                  </svg>
                </div>
              </div>
            </motion.div>}
            <motion.div variants={child}>
              <div className="mt-5 p-10" id="cs">
                <Select
                  defaultValue={type}
                  // defaultValue="All Positions"
                  style={{ width: "100%" }}
                  onChange={(value) => setType(value)}
                  suffixIcon={
                    <svg
                      width="14"
                      height="10"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.66667 10L0 0H14L6.66667 10Z"
                        fill="var(--fnt)"
                      />
                    </svg>
                  }
                  className="history-select"
                  options={[
                    // { value: "AllPositions", label: "All Positions" },
                    { value: "binary", label: "Binary" },
                    // { value: "forex", label: "Forex" },
                    { value: "future", label: "Futures" },
                    // { value: "disabled", label: "Disabled", disabled: true },
                  ]}
                  id="cs"
                />
              </div>
            </motion.div>
            <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
              {/* ...your header and filters above... */}
              <div style={{ flex: 1, overflowY: "auto" }}>
                {data?.length > 0 ? <List
                  itemLayout="horizontal"
                  dataSource={data}
                  renderItem={(item, index) => (
                    <motion.div variants={child} key={item.id || index}>
                      <List.Item
                        style={{
                          // background: "#1e293b",
                          // borderRadius: 8,
                          marginBottom: 6,
                          padding: "5px 12px",
                          borderBottom: "1px solid #f7a60047",
                          display: "flex",
                        }}
                      >
                        <Row style={{ width: "100%" }} align="middle">
                          {/* Left - Time and Date */}
                          {/* <Col span={4}>
                                                        <Text style={{ color: "#fff" }} className='time-h'>{item.time}</Text>
                                                        <br />
                                                        <Text type="secondary" className='date-h '>{item.date}</Text>
                                                    </Col> */}

                          {/* Middle - Icon + Pair + Type */}
                          <Col
                            span={16}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                              paddingLeft: "12px",
                            }}
                          >
                            <div>
                              {item.icon ? (
                                <img
                                  src={item.icon}
                                  alt={item.pair}
                                  style={{
                                    width: 32,
                                    height: "auto",
                                    marginRight: 8,
                                  }}
                                />
                              ) : (
                                <Avatar
                                  style={{
                                    width: 38,
                                    height: "38px",
                                    marginRight: 8,
                                    marginLeft: "-5px",
                                  }}
                                >
                                  {item?.pair}
                                </Avatar>
                              )}

                              {/* <div style={{ marginTop: "-5px" }}>
                                                                <Text type="secondary" className='type-h'>{item.type}</Text>

                                                            </div> */}
                            </div>

                            <div>
                              <Text
                                style={{ color: "var(--fnt)" }}
                                className="pair-h"
                              >
                                {item?.pair}
                              </Text>
                              <br />
                              <Badge
                                status={
                                  type === "binary" ? item.type === "high" ? "success" : "error" : item.type === "buy" ? "success" : "error"
                                }
                                text={
                                  item.type?.charAt(0)?.toUpperCase() +
                                  item.type?.slice(1)
                                }
                              />
                            </div>
                          </Col>

                          {/* Right - Profit/Loss + Investment */}
                          <Col span={8} style={{ textAlign: "right" }}>
                            <Text
                              style={{
                                color: item.result >= 0 ? "#1BA136" : "#D74C39",
                                // fontWeight: 600,
                              }}
                              className="result-h"
                            >
                              {item.result >= 0
                                ? `+$${item.result}`
                                : `-$${Math.abs(item.result)}`}
                            </Text>
                            <br />
                            <div className="display-4 gap-5 mt-5">
                              <Text type="secondary" className="date-h ">
                                ${item.investment}
                              </Text>{" "}
                              {item.result >= 0 ? (
                                <svg
                                  width="14"
                                  height="10"
                                  viewBox="0 0 14 10"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.66667 0L0 10H14L6.66667 0Z"
                                    fill="#009C34"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="14"
                                  height="10"
                                  viewBox="0 0 14 10"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.66667 10L0 0H14L6.66667 10Z"
                                    fill="#EC5039"
                                  />
                                </svg>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </List.Item>
                    </motion.div>
                  )}
                /> : <div style={{ display: "flex", alignItems: 'center', justifyContent: "center", height: "100%" }}>
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>}
              </div>
            </div>
          </motion.div>
        </>
      )}
    </>
  );
};

export default TradeHitorySide;
